import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';

export class FiduciarySubmissionIndividualEntity implements Deserializable {
  public id!: string;
  public legalFiduciaryIndividualEntityId!: number | null;
  public firstName!: string;
  public lastName!: string;
  public birthDate!: string | null;
  public phoneNumber!: string;
  public phoneNumberCountryCode!: string;
  public email!: string;
  public address!: Address | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.address) {
      this.address = Deserialize.instanceOf(Address, this.address);
    }
  }
}
